import { CmsMeta } from '../cms/cmsMeta';
import { ReactNode } from 'react';
import './CheckmarkList.css';

export const CheckmarkList = ({ children, className }: { children: ReactNode; className?: string }) => {
	return <ul className={`${className} checkmark-list`}>{children}</ul>;
};

export const cmsMeta: CmsMeta = {
	description: 'A list with a checkmark before each item, for the reasons-to-buy blocks. Children are `li` nodes.',
	example: [
		'CheckmarkList',
		{ index: 2 },
		['li', { index: 0 }, ['strong', { index: 0 }, 'Einfach '], ' – Deutschlands größtes Sortiment'],
		['li', { index: 1 }, ['strong', { index: 0 }, 'Günstig '], ' – Niedrige Preise und Bonus auf alle Einkäufe'],
	],
};
